/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-plusplus */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Button } from "antd";
import LongGraph from "components/Tablets/LongGraph";
import PoliciesActions from "services/policies/actions";
import AutoSvg from "assets/images/pia-brands/auto.svg";
import DamageSvg from "assets/images/pia-brands/damage.svg";
import GmmSvg from "assets/images/pia-brands/gmm-icon.svg";
import VidaSvg from "assets/images/vida.svg";
import AutoGreenSvg from "assets/images/icons-line-product-green/Autos-green-svg.svg";
import DamageGreenSvg from "assets/images/pia-brands/damage-green.svg";
import GmmGreenSvg from "assets/images/pia-brands/gmm-icon-green.svg";
import VidaGreenSvg from "assets/images/vida-green.svg";
import SaludPurpleSvg from "assets/images/salud-svg-purple.svg";
import SaludGreenSvg from "assets/images/salud-svg-green.svg";
import { func, number, objectOf } from "prop-types";
import parseThousandNumber from "common/utils/parseThousandNumber";
import Loader from "components/loader";
import topRamo from "../../../../common/utils/topRamo";

const CardTotals = ({ summary, optionSelected, setoptionSelected, isDateBranches }) => {
  const [dataPoint, setDataPoint] = useState(undefined);
  const [isoptions, setoptions] = useState(undefined);
  const [isTypeGraph, setTypeGraph] = useState("line");
  const dispatch = useDispatch();
  const policiesStore = useSelector((state) => state.policies);
  const styleDark = useSelector((state) => state.policies.styleDark);

  useEffect(() => {
    if (
      !policiesStore.loading.insurances &&
      !policiesStore.success.insurances &&
      !policiesStore.error.insurances
    )
      dispatch(PoliciesActions.getAllInsurances());
  }, [policiesStore, dispatch]);

  useEffect(() => {
    const arrayX = [];
    let arrayMonth = [];

    for (let index = 0; index < policiesStore?.success?.commissions?.chartData?.length; index++) {
      arrayMonth = [...arrayMonth, policiesStore?.success?.commissions?.chartData[index].month];
    }
    const newMonthsOrder = arrayMonth.sort();

    for (let index = 0; index < newMonthsOrder?.length; index++) {
      for (let j = 0; j < policiesStore?.success?.commissions?.chartData?.length; j++) {
        if (newMonthsOrder[index] === policiesStore?.success?.commissions.chartData[j]?.month) {
          arrayX.push(policiesStore?.success?.commissions.chartData[j].value);
        }
      }
    }

    const arrayX2 = [];
    for (let index = 0; index < arrayX.length; index++) {
      arrayX2.push(`$${arrayX[index]}`);
    }
    const Months = [];
    for (let index = 0; index < newMonthsOrder.length; index++) {
      Months.push(moment(newMonthsOrder[index]).format("MMM YYYY"));
    }

    setDataPoint([{ name: "pagos", data: arrayX, months: arrayMonth }]);
    if (styleDark) {
      setoptions({
        chart: {
          height: 300,
          type: "line",
        },
        stroke: {
          width: 3,
          curve: "smooth",
        },
        labels: arrayX2,
        xaxis: {
          categories: Months,
          title: {
            text: "Fechas",
          },
        },
        dataLabels: {
          enabled: false,
          labels: arrayX2,
          formatter: (value) =>
            new Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(value),
        },
        colors: ["#7F14FC", "#7F14FC", "#7F14FC", "#7F14FC"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            gradientToColors: ["#5D30DD"],
            shadeIntensity: 1,
            type: "horizontal",
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 0, 0, 0],
          },
        },
        markers: {
          size: 7,
          colors: ["#35D8D0"],
          strokeColors: "#fff",
          strokeWidth: 1,
          hover: {
            size: 4,
          },
        },
        yaxis: {
          title: {
            text: "Mxn",
          },
          labels: {
            formatter: (value) =>
              new Intl.NumberFormat("es-MX", {
                style: "currency",
                currency: "MXN",
              }).format(value),
          },
        },
      });
    } else {
      setoptions({
        chart: {
          height: 300,
          type: "line",
        },
        stroke: {
          width: 3,
          curve: "smooth",
        },
        labels: arrayX2,
        xaxis: {
          categories: Months,
          title: {
            text: "Fechas",
          },
        },
        dataLabels: {
          enabled: false,
          labels: arrayX2,
          formatter: (value) =>
            new Intl.NumberFormat("es-MX", {
              style: "currency",
              currency: "MXN",
            }).format(value),
        },
        colors: ["#7F14FC", "#7F14FC", "#7F14FC", "#7F14FC"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            gradientToColors: ["#5D30DD"],
            shadeIntensity: 1,
            type: "horizontal",
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 0, 0, 0],
          },
        },
        markers: {
          size: 7,
          colors: ["#4B3A7C"],
          strokeColors: "#fff",
          strokeWidth: 1,
          hover: {
            size: 4,
          },
        },
        yaxis: {
          title: {
            text: "Mxn",
          },
          labels: {
            formatter: (value) =>
              new Intl.NumberFormat("es-MX", {
                style: "currency",
                currency: "MXN",
              }).format(value),
          },
        },
      });
    }
  }, [policiesStore, styleDark]);

  useEffect(() => {
    dispatch(PoliciesActions.getCommissions());
  }, [dispatch]);
  const dummyMonth = [
    { id: 1, title: "24M", cantDays: 24 },
    { id: 2, title: "12M", cantDays: 12 },
    { id: 3, title: "6M", cantDays: 6 },
    { id: 4, title: "3M", cantDays: 3 },
  ];
  const changeFiltreCommissiones = (item) => {
    setoptionSelected(item.id);
    dispatch(
      PoliciesActions.setFiltersCommissions(
        "Fechas",
        moment().subtract(item.cantDays, "month").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      )
    );
  };
  return (
    <div className="CardTotals">
      <div className="CardTotals__head">
        <div className="flex">
          <h1 className="h1-mobile">Totales</h1>
          <div className="types">
            <p className="small-detail">Tipo de gráfica</p>
            <Button
              onClick={() => setTypeGraph("bar")}
              className={`${isTypeGraph === "bar" && "btn-active"}`}
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.86536 12.835C1.45286 12.835 1.09961 12.688 0.805607 12.394C0.511608 12.1 0.364858 11.747 0.365358 11.335V6.08496C0.365358 5.67246 0.512358 5.31921 0.806357 5.02521C1.10036 4.73121 1.45336 4.58446 1.86536 4.58496C2.27786 4.58496 2.63111 4.73196 2.92511 5.02596C3.21911 5.31996 3.36586 5.67296 3.36536 6.08496V11.335C3.36536 11.7475 3.21836 12.1007 2.92436 12.3947C2.63036 12.6887 2.27736 12.8355 1.86536 12.835ZM6.36536 12.835C5.95286 12.835 5.59961 12.688 5.30561 12.394C5.01161 12.1 4.86486 11.747 4.86536 11.335V2.33496C4.86536 1.92246 5.01236 1.56921 5.30636 1.27521C5.60036 0.981212 5.95336 0.834462 6.36536 0.834962C6.77786 0.834962 7.13111 0.981962 7.42511 1.27596C7.71911 1.56996 7.86586 1.92296 7.86536 2.33496V11.335C7.86536 11.7475 7.71836 12.1007 7.42436 12.3947C7.13036 12.6887 6.77736 12.8355 6.36536 12.835ZM10.8654 12.835C10.4529 12.835 10.0996 12.688 9.80561 12.394C9.51161 12.1 9.36486 11.747 9.36536 11.335V9.08496C9.36536 8.67246 9.51235 8.31921 9.80636 8.02521C10.1004 7.73121 10.4534 7.58446 10.8654 7.58496C11.2779 7.58496 11.6311 7.73196 11.9251 8.02596C12.2191 8.31996 12.3659 8.67296 12.3654 9.08496V11.335C12.3654 11.7475 12.2184 12.1007 11.9244 12.3947C11.6304 12.6887 11.2774 12.8355 10.8654 12.835Z"
                  fill="#5D30DD"
                />
              </svg>
            </Button>
            <Button
              onClick={() => setTypeGraph("line")}
              className={`${isTypeGraph === "line" && "btn-active"}`}
            >
              <svg
                width="15"
                height="12"
                viewBox="0 0 15 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.7 6.09459C5.54482 6.09222 5.39039 6.0725 5.23959 6.03581L4.23369 7.92445C4.66789 8.28845 4.94398 8.8349 4.94398 9.44582C4.94398 10.5417 4.05556 11.4302 2.95964 11.4302C1.86372 11.4302 0.975296 10.5417 0.975296 9.44582C0.975296 8.3499 1.86372 7.46148 2.95964 7.46148C3.0931 7.46148 3.22348 7.47466 3.34956 7.49978L4.37755 5.57051C4.15504 5.37082 3.98119 5.12286 3.8693 4.84561C3.75741 4.56837 3.71046 4.26919 3.73204 3.971C3.75361 3.67281 3.84315 3.38351 3.99379 3.12527C4.14442 2.86702 4.35217 2.64667 4.6011 2.4811C4.85004 2.31553 5.13357 2.20912 5.42997 2.17004C5.72638 2.13095 6.0278 2.16022 6.31115 2.2556C6.59449 2.35098 6.85226 2.50994 7.06469 2.72031C7.27712 2.93068 7.43859 3.18688 7.53673 3.46928C7.63086 3.72035 7.6708 3.98849 7.65391 4.25609C7.63703 4.52369 7.56371 4.78469 7.43877 5.02193L9.01592 6.42765C9.33885 6.21064 9.71909 6.09469 10.1082 6.09459C10.2465 6.09418 10.3845 6.10897 10.5196 6.13867L11.7637 3.64561C11.4499 3.37608 11.2294 3.01415 11.1339 2.61166C11.0384 2.20918 11.0728 1.7868 11.2321 1.40503C11.3913 1.02326 11.6674 0.701703 12.0206 0.486423C12.3738 0.271143 12.7861 0.17319 13.1984 0.206596C13.6107 0.240003 14.0019 0.403055 14.3158 0.672393C14.6298 0.94173 14.8505 1.30353 14.9462 1.70596C15.0419 2.10839 15.0078 2.53079 14.8488 2.91265C14.6897 3.29452 14.4139 3.61624 14.0608 3.83173C13.8529 3.96859 13.6195 4.06212 13.3746 4.10673C13.1297 4.15133 12.8783 4.14609 12.6355 4.09132L11.3914 6.58438C11.6208 6.77951 11.8021 7.0249 11.9213 7.30149C12.0405 7.57807 12.0943 7.87841 12.0785 8.17916C12.0628 8.47991 11.9779 8.77298 11.8305 9.03561C11.6831 9.29823 11.4771 9.52334 11.2286 9.69344C10.9801 9.86355 10.6957 9.97407 10.3975 10.0164C10.0994 10.0588 9.79544 10.0318 9.50938 9.93763C9.22332 9.84346 8.96282 9.6846 8.74812 9.47341C8.53342 9.26221 8.3703 9.00436 8.27143 8.71989C8.1773 8.46883 8.13736 8.20068 8.15425 7.93308C8.17113 7.66548 8.24445 7.40449 8.36939 7.16724L6.79224 5.76153C6.46931 5.97854 6.08907 6.09448 5.7 6.09459ZM13.5912 1.36172C13.4301 1.25408 13.2407 1.19663 13.0469 1.19663C12.7871 1.19663 12.538 1.29983 12.3543 1.48354C12.1706 1.66725 12.0673 1.91642 12.0673 2.17622C12.0673 2.36996 12.1248 2.55936 12.2324 2.72045C12.3401 2.88154 12.4931 3.0071 12.6721 3.08124C12.8511 3.15539 13.048 3.17479 13.238 3.13699C13.4281 3.09919 13.6026 3.00589 13.7396 2.8689C13.8766 2.7319 13.9699 2.55735 14.0077 2.36733C14.0455 2.17731 14.0261 1.98034 13.952 1.80135C13.8778 1.62235 13.7523 1.46936 13.5912 1.36172ZM10.9227 8.598C11.0303 8.43691 11.0878 8.24752 11.0878 8.05377C11.0878 7.79397 10.9845 7.5448 10.8008 7.3611C10.6171 7.17739 10.368 7.07418 10.1082 7.07418C9.91442 7.07418 9.72502 7.13163 9.56393 7.23927C9.40284 7.34691 9.27728 7.4999 9.20314 7.6789C9.12899 7.85789 9.10959 8.05486 9.14739 8.24488C9.18519 8.4349 9.27849 8.60945 9.41549 8.74645C9.55248 8.88345 9.72703 8.97674 9.91705 9.01454C10.1071 9.05234 10.304 9.03294 10.483 8.9588C10.662 8.88465 10.815 8.7591 10.9227 8.598ZM6.24423 3.3209C6.08314 3.21326 5.89374 3.15581 5.7 3.15581C5.44019 3.15581 5.19103 3.25902 5.00732 3.44273C4.82361 3.62644 4.7204 3.8756 4.7204 4.1354C4.7204 4.32915 4.77786 4.51854 4.8855 4.67964C4.99313 4.84073 5.14613 4.96629 5.32512 5.04043C5.50412 5.11457 5.70108 5.13397 5.89111 5.09617C6.08113 5.05837 6.25567 4.96508 6.39267 4.82808C6.52967 4.69108 6.62297 4.51653 6.66077 4.32651C6.69856 4.13649 6.67917 3.93953 6.60502 3.76053C6.53088 3.58153 6.40532 3.42854 6.24423 3.3209ZM4.08683 9.44582C4.08683 10.0684 3.58217 10.573 2.95964 10.573C2.3371 10.573 1.83244 10.0684 1.83244 9.44582C1.83244 8.82329 2.3371 8.31863 2.95964 8.31863C3.58217 8.31863 4.08683 8.82329 4.08683 9.44582Z"
                  fill="white"
                />
              </svg>
            </Button>
          </div>
        </div>
      </div>

      <div className="CardTotals__content">
        <div>
          <p className="small-detail">
            {moment(isDateBranches?.FechaInicial[0]).format("MMM'YY")}-
            {moment(isDateBranches?.FechaFinal[0]).format("MMM'YY")}
          </p>
          {policiesStore?.success?.commissions?.totalValue ? (
            <h1 className="h1-gradient">
              ${parseThousandNumber(policiesStore?.success?.commissions?.totalValue)}
            </h1>
          ) : (
            <h1 className="h1-gradient">$0M</h1>
          )}
        </div>
        <div className="divider" />
        <div className="row row--absolut">
          <div className="row-column">
            <div className="circle circle--insure">
              <img src={summary?.insuranceTop?.logo} alt="insurance" className="icon" />
            </div>
            <div className="item">
              <p className="small-detail">Top Aseguradora</p>
              <p className="body-bold">{summary?.insuranceTop?.key}</p>
            </div>
          </div>
          <div className="row-column">
            <div className="circle">
              {styleDark ? (
                <>
                  {topRamo(summary?.branchTop || "") === "autos" && (
                    <img src={AutoGreenSvg} alt="insurance" className="icon" />
                  )}
                  {topRamo(summary?.branchTop || "") === "daños" && (
                    <img src={DamageGreenSvg} alt="insurance" className="icon" />
                  )}
                  {topRamo(summary?.branchTop || "") === "vida" && (
                    <img src={VidaGreenSvg} alt="insurance" className="icon" />
                  )}
                  {topRamo(summary?.branchTop || "") === "gmm" && (
                    <img src={GmmGreenSvg} alt="insurance" className="icon" />
                  )}
                  {topRamo(summary?.branchTop || "") === "salud" && (
                    <img src={SaludGreenSvg} alt="insurance" className="icon" />
                  )}
                </>
              ) : (
                <>
                  {topRamo(summary?.branchTop || "") === "autos" && (
                    <img src={AutoSvg} alt="insurance" className="icon" />
                  )}
                  {topRamo(summary?.branchTop || "") === "daños" && (
                    <img src={DamageSvg} alt="insurance" className="icon" />
                  )}
                  {topRamo(summary?.branchTop || "") === "vida" && (
                    <img src={VidaSvg} alt="insurance" className="icon" />
                  )}
                  {topRamo(summary?.branchTop || "") === "gmm" && (
                    <img src={GmmSvg} alt="insurance" className="icon" />
                  )}
                  {topRamo(summary?.branchTop || "") === "salud" && (
                    <img src={SaludPurpleSvg} alt="insurance" className="icon" />
                  )}
                </>
              )}
            </div>
            <div className="item">
              <p className="small-detail">Top Ramo</p>
              <p className="body-bold">{summary?.branchTop}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="row row-foo">
        {policiesStore?.loading?.commissions ? (
          <Loader className="loader-small" />
        ) : (
          <>
            <div className="row-data">
              <p className="small-detail">Próximo corte:</p>
              <p className="h3">En {policiesStore?.success?.commissions?.nextCloseDay} días</p>
            </div>
            <div className="row-data">
              <p className="small-detail">Proyección:</p>
              <p className="h3">
                +${parseThousandNumber(policiesStore?.success?.commissions?.projection)}
              </p>
            </div>
          </>
        )}
      </div>
      <div className="content-filters">
        {dummyMonth?.map((item) => (
          <Button
            className={`btn ${item.id === optionSelected && "btn--active"}`}
            key={item.id}
            onClick={() => changeFiltreCommissiones(item)}
          >
            {item.title}
          </Button>
        ))}
      </div>
      <div className="graphs">
        <div className={`graphs--${isTypeGraph === "bar" && "active"}`}>
          <LongGraph
            width="100%"
            height={320}
            type="bar"
            data={policiesStore?.success?.commissions?.chartData}
            dataPoint={dataPoint}
            isoptions={isoptions}
            loading={policiesStore?.loading?.filtersCommissions}
          />
        </div>
        <div className={`graphs--${isTypeGraph === "line" && "active"}`}>
          <LongGraph
            width="100%"
            height={320}
            type="line"
            data={policiesStore?.success?.commissions?.chartData}
            dataPoint={dataPoint}
            isoptions={isoptions}
            loading={policiesStore?.loading?.filtersCommissions}
          />
        </div>
      </div>
    </div>
  );
};
CardTotals.propTypes = {
  summary: objectOf.isRequired,
  isDateBranches: objectOf.isRequired,
  optionSelected: number.isRequired,
  setoptionSelected: func.isRequired,
};
export default CardTotals;
